import React, { useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AntdThemeProvider } from './theme/components/AntdThemeProvider'
import { Router } from './routes'
import { CookieConsentComponent } from './components/CookieConsent'
const queryClient = new QueryClient()
import { I18nextProvider } from 'react-i18next'
import i18next from './i18n'

function App() {
  const [, setLanguage] = useState(i18next.language)

  useEffect(() => {
    const handleLanguageChanged = (language: string) => setLanguage(language)
    i18next.on('languageChanged', handleLanguageChanged)
    document.title = i18next.t('ui.document_title')
    return () => {
      i18next.off('languageChanged', handleLanguageChanged)
    }
  }, [])

  useEffect(() => {
    document.title = i18next.t('ui.document_title')
  }, [i18next.language])

  return (
    <div className="App h-screen">
      <I18nextProvider i18n={i18next} defaultNS={'translation'}>
        <AntdThemeProvider>
          <QueryClientProvider client={queryClient}>
            <Router />
            <CookieConsentComponent />
          </QueryClientProvider>
        </AntdThemeProvider>
      </I18nextProvider>
    </div>
  )
}

export default App
